import { initialFilter } from "app/modules/schedule/ScheduleUIHelpers";
import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// REDUX
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getListSchedule } from "../../redux/schedule";

const AuthUIContext = createContext();

export const useAuthUIContext = () => {
  return useContext(AuthUIContext);
};

export const AuthUIConsumer = AuthUIContext.Consumer;

export function AuthUIProvider({ children }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [signUpData, setSignUpData] = useState({});

  const { getListScheduleData } = useSelector(
    (state) => ({
      getListScheduleData: state.GetListScheduleData,
    }),
    shallowEqual
  );
  const { data, isLoading } = getListScheduleData;

  useEffect(() => {
    dispatch(getListSchedule(initialFilter));
  }, [dispatch]);

  const dataUIEvents = {
    goToSignUp: () => {
      navigate(`/auth/sign-up`, {
        state: {
          showDialog: true,
        },
      });
    },
  };

  const value = {
    data,
    isLoadingData: isLoading,
    signUpData,
    setSignUpData,
    goToSignUp: dataUIEvents.goToSignUp,
  };

  return (
    <AuthUIContext.Provider value={value}>{children}</AuthUIContext.Provider>
  );
}
